import { ChangeDetectionStrategy, Component, inject, input, InputSignal } from '@angular/core';
import { TABLE_THEME, TableTheme } from '../../types/table-theme.type';

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  selector: 'app-table-header',
  standalone: true,
  templateUrl: './table-header.component.html',
  host: { "[style.width.px]": "width()" },
  styleUrl: './table-header.component.scss'
})
export class TableHeaderComponent {
  private _theme: TableTheme = inject(TABLE_THEME);

  public width: InputSignal<number> = input<number>(this._theme.defaultColumnWidth);

  public isFixed: InputSignal<boolean | undefined> = input<boolean | undefined>(false);
}
